import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estrutura-list',
  templateUrl: './estrutura-list.component.html',
  styleUrls: ['./estrutura-list.component.scss']
})
export class EstruturaListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
